import config from '@/api/config'

let subUrl = '/product/category'

export default {
  getProducts: {
    url: function (id) {
      return config.baseUrl + config.version3 + subUrl + '/products'
    }
  }
}
